import { gql } from '@apollo/client';

// TODO: remove this custom query once we remove ALL flags related to org level settings
export const buildGetOrgLevelSettings = flags => {
  const {
    isRiseAiConversationalGptEnabled = false,
    isRiseAIInsightsReportEnabled = false,
    isAutoRemediationsSettingsEnabled = false,
    isSecretScanningSettingsEnabled = false,
    isAdvancedSettingsEnabled = false
  } = flags;

  const fields = ['idleTimoutEnabled', 'idleTimeoutSeconds'];

  // AI Settings fields
  if (isRiseAiConversationalGptEnabled) {
    fields.push('riseAiConversationalGptEnabled');
  }
  if (isRiseAIInsightsReportEnabled) {
    fields.push('riseAiInsightsReportEnabled');
  }

  // Auto-Remediations Settings fields
  if (isAutoRemediationsSettingsEnabled) {
    fields.push('kernelVulnerabilitiesEnabled', 'status', 'justification', 'response');
  }

  // Secret Scanning Settings fields
  if (isSecretScanningSettingsEnabled) {
    fields.push('verifyCredentialsEnabled');
  }

  // Advanced Settings fields
  if (isAdvancedSettingsEnabled) {
    fields.push(
      'heuristicEnabled',
      'cryptographicHashEnabled',
      'packageManagerEnabled',
      'functionHashingEnabled',
      'symbolIndexEnabled',
      'kernelModuleEnabled',
      'curatedHashEnabled',
      'legacyHashEnabled',
      'packageManifestEnabled',
      'signatureEnabled',
      'peMetaDataEnabled',
      'libraryVersionEnabled',
      'libraryNameEnabled',
      'binaryFingerprintEnabled'
    );
  }

  const queryString = `
    query getOrgLevelSettings {
      orgLevelSettings {
        ${fields.join('\n')}
      }
    }
  `;

  return gql(queryString);
};

export const buildUpdateOrgLevelSettings = flags => {
  // Mutation structure doesn't change based on flags, only the input fields sent
  // The mutation itself always accepts the same input type
  return gql`
    mutation updateOrgLevelSettings($args: OrgLevelSettingsInput!) {
      updateOrgLevelSettings(args: $args) {
        err
      }
    }
  `;
};


// TODO: use this query instead of the custom one above once we remove ALL flags related to org level settings
export const UPDATE_ORG_LEVEL_SETTINGS = gql`
  mutation updateOrgLevelSettings($args: OrgLevelSettingsInput!) {
    updateOrgLevelSettings(args: $args) {
      err
    }
  }
`;

// TODO: use this query instead of the custom one above once we remove ALL flags related to org level settings
export const GET_ORG_LEVEL_SETTINGS = gql`
  query getOrgLevelSettings {
    orgLevelSettings {
      idleTimoutEnabled
      idleTimeoutSeconds
      riseAiConversationalGptEnabled
      riseAiInsightsReportEnabled
      kernelVulnerabilitiesEnabled
      status
      justification
      response
      verifyCredentialsEnabled
      heuristicEnabled
      cryptographicHashEnabled
      packageManagerEnabled
      functionHashingEnabled
      symbolIndexEnabled
      kernelModuleEnabled
      curatedHashEnabled
      legacyHashEnabled
      packageManifestEnabled
      signatureEnabled
      peMetaDataEnabled
      libraryVersionEnabled
      libraryNameEnabled
      binaryFingerprintEnabled
    }
  }
`;
